import $ from 'jquery';
import React from 'react';
import OptionPopupView from "views/common/OptionPopupView";
import { createRoot } from "react-dom/client";
import { MoveToFolderContent } from '../../components/common/MoveToFolderContent';

const MoveToFolderPopupView = OptionPopupView.extend({

    "pageName": "Move To Folder Popup",

    initialize: function(options) {
        this._folders = options.folders;
        this._currentFolderId = options.currentFolderId;
        this._onConfirm = options.onConfirm;
        this._onCancel = options.onCancel;
        this._ti18n = options.ti18n;
        this._reactRoot = null;

        // Create content container for React component
        this.contentContainer$el = $('<div class="move-to-folder-popup-content"></div>');
        this.contentContainer$el.css("width", "calc(100% - 40px)");
        this.contentContainer$el.css("max-width", "500px");

        // Configure OptionPopupView
        const contentView = {};
        contentView.$el = this.contentContainer$el;

        const viewOptions = {
            contentView: contentView,
            contentPosition: "text-not-white",
            addContentAfterEnhancement: true,
            displayTitle: false,
            id: "MoveToFolderPopup"
        };

        OptionPopupView.prototype.initialize.call(this, viewOptions);
    },

    onPopupClosed: function() {
        if (this._onCancel) {
            this._onCancel();
            this._onCancel = null;
        }
        if (this._reactRoot) {
            this._reactRoot.unmount();
            this._reactRoot = null;
        }
    },

    onConfirmTriggered: async function(folderId) {
        try {
            if (this._onConfirm) {
                await this._onConfirm(folderId);
            }
        } catch (error) {
            console.error("Error in move-to-folder confirm:", error);
        } finally {
            this.close();
        }
    },

    onCancelTriggered: function() {
        if (this._onCancel) {
            this._onCancel();
        }
        this.close();
    },

    _renderReactComponent: function() {
        if (this._reactRoot) {
            this._reactRoot.unmount();
        }

        const root = createRoot(this.contentContainer$el.get(0));
        root.render(
            React.createElement(MoveToFolderContent, {
                folders: this._folders,
                currentFolderId: this._currentFolderId,
                onConfirm: this.onConfirmTriggered.bind(this),
                onCancel: this.onCancelTriggered.bind(this),
                ti18n: this._ti18n
            })
        );
        this._reactRoot = root;
    },

    addReactWidget: function() {
        this._renderReactComponent();
    },

    onAfterPageShow: function() {
        this.addReactWidget();
    },

    afterRender: function() {
        OptionPopupView.prototype.afterRender.call(this);
    }
});

export default MoveToFolderPopupView;
